import { render, staticRenderFns } from "./SearchPanoramaExcludedSubjects.vue?vue&type=template&id=2d218577&scoped=true"
import script from "./SearchPanoramaExcludedSubjects.vue?vue&type=script&lang=js"
export * from "./SearchPanoramaExcludedSubjects.vue?vue&type=script&lang=js"
import style0 from "./SearchPanoramaExcludedSubjects.vue?vue&type=style&index=0&id=2d218577&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d218577",
  null
  
)

export default component.exports